import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';
import {CreatePageHeader} from '../components/CreatePageHeader';
import {CreatePageNavigation} from "../navigation/CreatePageNavigation";
import {CreateForm} from "../forms/CreateForm.tsx";

export const CreatePage = () => {
    return (
        <SimplePageLayout
            pageHeader={<CreatePageHeader/>}
            pageNavigation={<CreatePageNavigation/>}
        >
            <SimplePageContentWrapper>
                <CreateForm/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};